import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import changeWalletAddress from "./locales/en/change-wallet-address.json";
import common from "./locales/en/common.json";
import components from "./locales/en/components.json";
import dashboard from "./locales/en/dashboard.json";
import home from "./locales/en/home.json";
import manageStaff from "./locales/en/manage-staff.json";
import myClaims from "./locales/en/my-claims.json";
import myCovers from "./locales/en/my-covers.json";
import myProfile from "./locales/en/my-profile.json";
import pageTitle from "./locales/en/page-title.json";
import purchaseCover from "./locales/en/purchase-cover.json";
import purchaseTraditionalInsurance from "./locales/en/purchase-traditional-insurance.json";
import raiseNewClaim from "./locales/en/raise-new-claim.json";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "en",
  resources: {
    en: {
      common,
      dashboard,
      purchaseCover,
      purchaseTraditionalInsurance,
      myCovers,
      myClaims,
      changeWalletAddress,
      myProfile,
      raiseNewClaim,
      manageStaff,
      pageTitle,
      components,
      home,
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["en"];

export { default } from "i18next";
